export default __webpack_public_path__ + "static/media/4-2_image16@2x.12829a87.png";